
import { Component, Vue, Prop, Emit } from 'vue-property-decorator'

export interface ChangeOption {
    status: string,
    target: any
}


/**
 * 
 * @prop   value    申请列表数据  
 * @emit   change   修改状态
 * 
*/
@Component({
    name: 'deletenewsapply-table'
})
export default class extends Vue {
    private statusOptions = [
        { value: '审核中', key: 'PENDING' },
        { value: '通过', key: 'APPROVED' },
        { value: '不通过', key: 'REJECTED' }
    ]
    @Prop({ required: true }) private value!: any[]

    @Emit('change')
    private onStatusSelect(e: any, row: any) {
        const option: ChangeOption = {
            status: e,
            target: row
        }
        return option
    }
}
